<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="650px"
    bodyHeight="400px"
    class="import-log-modal"
    @close="onChange"
  >
    <div slot="title">{{ $t('stores::products-info::import_log') }}</div>
    <z-table
      ref="table"
      v-loading="loading"
      :data="tableData"
      :columns="columns"
      :max-height="280"
      :pagination.sync="pagination"
      @page-change="getList"
    >
      <template #status="{ row }">
        <span>
          {{ row.status === 1 ? $t('stores::products-info::had_complete') : $t('stores::products-info::ongoing') }}
        </span>
      </template>
      <template #operate="{ row }">
        <el-button v-if="row.importFailNum" @click="onClick(row.failDataUrl)" type="text">
          {{ $t('stores::products-info::import_fail_log') }}
        </el-button>
      </template>
    </z-table>
  </el-dialog>
</template>
<script>
import { getImportLogList } from '@/server/product.js'
export default {
  name: 'modal-back-email',
  components: {},
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible(bool) {
      this.show = bool
      if (bool) {
        this.pagination.pageNum = 1
        this.pagination.pageSize = 20
        this.getList()
      }
    },
    drawRow: {
      handler: function(data) {},
      deep: true
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      columns: [
        {
          prop: 'importTime',
          label: this.$t('stores::products-info::import_time'),
          fixed: 'left',
          minWidth: '200',
          formatter: row => this.$dataCheck(row.importTime)
        },
        {
          prop: 'importTotal',
          label: this.$t('stores::products-info::import_number'),
          minWidth: '150',
          formatter: row => this.$dataCheck(row.importTotal)
        },
        {
          prop: 'successNum',
          label: this.$t('stores::products-info::success_number'),
          minWidth: '150',
          formatter: row => this.$dataCheck(row.successNum)
        },
        {
          prop: 'importFailNum',
          label: this.$t('stores::products-info::fail_number'),
          minWidth: '150',
          formatter: row => this.$dataCheck(row.importFailNum)
        },
        {
          prop: 'status',
          label: this.$t('stores::products-info::status'),
          minWidth: '100'
        },
        {
          prop: 'operate',
          label: this.$t('stores::products-info::operate'),
          width: '180',
          fixed: 'right'
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0
      },
      params: {}
    }
  },
  mounted() {},
  methods: {
    async getList() {
      this.loading = true
      const { data } = await getImportLogList({
        ...this.params,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.pageNum
      })
      console.log(data)
      this.loading = false
      if (data.code === this.$code) {
        this.tableData = data.data.list
        this.pagination.total = data.data.total
      }
    },
    onClick(url) {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.download = 'file.xlsx'
      document.body.appendChild(link)
      link.click()
    },
    onChange() {
      this.$emit('change', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.import-log-modal {
}
</style>
